import React from "react";
import { connect } from "react-redux";
import LocalizedStrings from "react-localization";
import { localisedText } from "../../../lib/localisation.es6";
import PolicyHeader from "./Components/PolicyHeader/PolicyHeader";
import { getEnviroment } from "../../../lib/utils.es6";
import { getAuthorizationToken, getPartnerGuid } from "../../../lib/access.es6";

class GeneratePolicy extends React.Component {
  constructor(props) {
    const localizedStrings = new LocalizedStrings(localisedText);
    super(props);
    this.state = {
      openRegisterCustomerDialog: false,
      labels: localizedStrings,
    };
  }

  render() {
     const partnerGuid = getPartnerGuid();
    const source = "aspin";
    const environment = getEnviroment()
    const stagingBaseUrl = "https://ipp-mazanu.staging.aspin-inclusivity.com";
    const productionBaseUrl = "https://ipp-mazanu.inclusivity-aspin.com";
    const baseUrl = environment === "prod" ? productionBaseUrl : stagingBaseUrl;
    const bearerToken = getAuthorizationToken();
    const host_base_url = window.location.origin;
    const iframeSrc = `${baseUrl}/?source=${encodeURIComponent(source)}&bearer_token=${encodeURIComponent(bearerToken)}&host_base_url=${encodeURIComponent(host_base_url)}&partner=${partnerGuid}`;



    console.log('iframe: ', iframeSrc)

    console.log("iframedetails",{
      source,
      environment,
      stagingBaseUrl,
      productionBaseUrl,
      baseUrl,
      bearerToken,
      host_base_url,
      partnerGuid
    })

    return (
      <>
        <PolicyHeader />
        <section
          style={{
            background: "#FFFFFF",
            borderRadius: "8px",
            height: "auto",
            marginTop: "30px",
            marginBottom: "30px",
            width: "100%",
          }}
        >
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{
              width: "100%",
              height: "calc(100vh - 100px)",
              border: "none",
            }}
            title="Insurance Quote"
          ></iframe>
        </section>
      </>
    );
  }
}

export default connect((state) => ({
  customerData: state.currentCustomer,
}))(GeneratePolicy);
